<template>
	<div class="container mt-3" v-if="VideoTypeEnum.WIDE_VIDEO !== data.type">
		<div class="video-card row p-0 m-0" v-if="VideoTypeEnum.WIDE_VIDEO !== data.type"
			 :class="videoPosition"
			 :style="{
				backgroundColor: data.section_background_color,
			 }"
		>
			<div class="col-12 p-0" :class="VideoTypeEnum.WIDE_VIDEO === data.type || VideoTypeEnum.CENTER_VIDEO === data.type ? '' : 'col-lg-6 '">
				<div class="video-container">
					<div v-if="data.url.includes('youtube') || data.url.includes('yt')" class="responsive-container" id="player"></div>
					<video v-else :autoplay="data.startOption === VideoStartOptionEnum.START_AUTO" muted loop controls>
						<source :src="data.url" type="video/mp4" width="200px">
						{{ translate('not-supported-video') }}
					</video>
				</div>
			</div>
			<div v-if="VideoTypeEnum.LEFT_VIDEO === data.type || VideoTypeEnum.RIGHT_VIDEO === data.type" class="col-12 col-lg-6 p-5 d-flex flex-column justify-content-between">
				<div class="text-container">
					<h2
							class="font-weight-bold mb-3"
					>
						{{ data.title }}
					</h2>
					<template v-for="item in this.convertedHtmlArray(this.data.lead, this.data.modules.forms, this.data.modules.documents)">
						<template v-if="item.hasOwnProperty('type')">
							<inline-document v-if="item.type === InlineModuleTypeEnum.DOCUMENT" :item="item.items"/>
							<inline-form v-if="item.type === InlineModuleTypeEnum.FORM" :item="item.items"/>
						</template>
						<p v-else v-html="item"></p>
					</template>
				</div>
				<template v-if="this.data?.button?.hasOwnProperty('url') && this.data?.button.url !== null">
					<a v-if="this.data?.button?.url?.includes('http')" :href="data.button.url" target="_blank">
						<button-unit
								class="float-end"
								:options="{
								text: data.button.title,
								type: 'button',
								shape: ButtonUnitShape.ROUNDED,
								textColor: data.button.color,
								bgColor: data.button.background,
						}"
						/>
					</a>
					<router-link v-else :to="{path: this.data?.button?.url}">
						<button-unit
								class="float-end"
								:options="{
								text: data.button.title,
								type: 'button',
								shape: ButtonUnitShape.ROUNDED,
								textColor: data.button.color,
								bgColor: data.button.background,
						}"
						/>
					</router-link>
				</template>
			</div>
		</div>
	</div>
	<div class="responsive-container" v-else>
		<div v-if="data.url.includes('youtube') || data.url.includes('yt')" class="responsive-container" id="player"></div>
		<div v-else style="padding-top: 56.25%;">
			<video :autoplay="data.startOption === VideoStartOptionEnum.START_AUTO" muted loop controls>
				<source :src="data.url" type="video/mp4" width="200px">
				{{ translate('not-supported-video') }}
			</video>
		</div>
	</div>

</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import ButtonUnit from "../Units/ButtonUnit.vue";
import {ButtonUnitShape} from "../Units/Interfaces/ButtonUnitShape";
import {InlineModuleMixin} from "../../Mixins/InlineModuleMixin";
import InlineDocument from "../InlineDocument.vue";
import InlineForm from "../InlineForm.vue";
import {InlineModuleTypeEnum} from "../../Views/PageView/Enums/InlineModuleTypeEnum";
import {VideoTypeEnum} from "../..//Views/PageView/Enums/VideoTypeEnum";
import {VideoComponentClass, VideoInterface} from "../../Views/PageView/Interfaces/Components/VideoInterface";
import {VideoStartOptionEnum} from "@/WebApp/Views/PageView/Enums/VideoStartOptionEnum";

export default defineComponent({
	name: "VideoCardComponent",
	components: {InlineDocument, InlineForm, ButtonUnit},
	mixins: [InlineModuleMixin],
	computed: {
		VideoStartOptionEnum() {
			return VideoStartOptionEnum
		},
		VideoTypeEnum() {
			return VideoTypeEnum
		},
		InlineModuleTypeEnum() {
			return InlineModuleTypeEnum
		},
		ButtonUnitShape() {
			return ButtonUnitShape
		},
		videoPosition(): string {
			return this.data.type === VideoTypeEnum.RIGHT_VIDEO ? 'flex-row-reverse' : 'flex-row';
		},
		videoUrl(): string {
			return this.data.url + '?autoplay=' + (this.data.type === VideoStartOptionEnum.START_AUTO ? '1' : '0') + '&controls=1';
		}
	},
	props: {
		data: {
			type: Object as PropType<VideoInterface>,
			default: new VideoComponentClass(),
			required: true,
		},
	},
	data() {
		return {
			player: null,
		}
	},
	mounted() {

		if (this.data.url.includes('youtube')) {
			let tag = document.createElement('script');
			tag.src = "https://www.youtube.com/iframe_api";
			let firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
			this.ytLoad();
		}
	},
	methods: {
		ytLoad(): void {

			let videoId = this.data.url.split('v=');
			setTimeout(() => {
				this.player = new YT.Player('player', {
					height: (this.data.type === VideoTypeEnum.WIDE_VIDEO ? '600' : '360'),
					width: (this.data.type === VideoTypeEnum.WIDE_VIDEO ? '100%' : '640'),
					videoId: videoId[1] ?? '',
					playerVars: {
						'autoplay': (this.data.startOption === VideoStartOptionEnum.START_AUTO),
						'mute': 0
					},
					events: {
						'onReady': this.onPlayerReady
					}
				});
			}, 1500);
		},
		onPlayerReady(event: any) {
			event.target.playVideo();
		}
	}
})
</script>

<style scoped>

</style>
